var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import Dropdown from '../dropdown';
import DropdownHeader from '../dropdown/header';
import DropdownItem from '../dropdown/item';
import DropdownMenu from '../dropdown/menu';
import { Styled } from './style';
var ChannelsDropdown = /** @class */ (function (_super) {
    __extends(ChannelsDropdown, _super);
    function ChannelsDropdown(props) {
        var _this = _super.call(this, props) || this;
        _this.handleChange = function (index, id) {
            if (_this.state.selectedItemId !== id) {
                _this.setState({
                    selectedItemIndex: index,
                    selectedItemId: id,
                });
                if (_this.props.onChange) {
                    _this.props.onChange(id);
                }
            }
        };
        _this.state = {
            selectedItemIndex: 0,
            selectedItemId: _this.props.currentChannelId,
        };
        return _this;
    }
    ChannelsDropdown.getDerivedStateFromProps = function (props, state) {
        if (props.currentChannelId !== state.selectedItemId) {
            return {
                selectedItemId: props.currentChannelId,
            };
        }
        // Return null if the state hasn't changed
        return null;
    };
    ChannelsDropdown.prototype.render = function () {
        var _this = this;
        var listChannels = this.props.channels.map(function (channel, index) { return (React.createElement(DropdownItem, { key: channel.id, value: channel.id, onClick: function () { return _this.handleChange(index, channel.id); } },
            React.createElement("h3", null, channel.name))); });
        var defaultChannel = this.props.channels.map(function (el) { return el.id; }).indexOf(this.state.selectedItemId);
        var selectedChannel = listChannels[defaultChannel];
        return (React.createElement(Styled, { className: "dropdown-channels" },
            React.createElement(Dropdown, { trigger: selectedChannel },
                React.createElement(DropdownMenu, null,
                    React.createElement(DropdownHeader, null,
                        React.createElement("h3", null,
                            React.createElement(FormattedMessage, { id: "ui_component.channels_dropdown.select_channel", defaultMessage: "Select Channel" }))),
                    listChannels))));
    };
    return ChannelsDropdown;
}(React.PureComponent));
export default ChannelsDropdown;
//# sourceMappingURL=index.js.map